import { FC } from "react";
import LoginRegister from "../LoginRegister/LoginRegister";

const userLoginStatus = () => {
  let returnType = "";
  returnType = localStorage.getItem("userUID");
  //onAuthStateChanged(auth, (user) => {
  return returnType;
};
const RequireAuth: FC<{ children: React.ReactElement }> = ({ children }) => {
  const userIsLogged = userLoginStatus(); // Your hook to get login status
  console.log(" userIsLogged = ", userIsLogged);
  if (userIsLogged === "") {
    return <LoginRegister />;
  } else {
    return children;
  }
};

export default RequireAuth;
